import { GSTypes } from "@mavles/shared";
import { IOrderElement } from "./order-element";


export interface IOrderProduct {
    product_id: number;
    product_name: string;
    product_image: string;
    product_image_id:string;
    product_unit: string;
    product_price: number;
    product_description: string;
    product_element_id: number;
    product_gs_type: GSTypes;
    created_by: number;
    updated_by: number;
    created_at: Date;
    updated_at: Date;
    deleted_at: Date;
  }
  
  export class OrderProduct implements IOrderProduct{
    constructor(element?:IOrderElement){
      if(element){
        this.product_element_id = element.element_id;
      }
    }
    
    product_id!: number;
    product_name!: string;
    product_image!:string;
    product_image_id!: string;
    product_unit!: string;
    product_price = 0.00;
    product_description!: string;
    product_element_id!: number ;
    product_gs_type = GSTypes.GOODS;
    created_by!: number;
    updated_by!: number;
    created_at!: Date;
    updated_at!: Date;
    deleted_at!: Date;
  }